
// src/utils/constants.js
import images from './images';  // Si están en la misma carpeta
export const SITE_URL = 'https://gruasbechan.cl';
export const COMPANY_NAME = 'Grúas Bechan';
export const PHONE_NUMBER = '+56940485185';
export const EMAIL = 'contacto@gruasbechan.cl';

export const NAVIGATION = [
  { name: 'Inicio', href: '/' },
  { name: 'Servicios', href: '/servicios' },
  { name: 'Blog', href: '/blog' },
  { name: 'Contacto', href: '/contacto' },
];

export const SOCIAL_MEDIA = {
  facebook: 'https://facebook.com/gruasbechan',
  instagram: 'https://instagram.com/gruasbechan',
  whatsapp: `https://wa.me/${PHONE_NUMBER}`
};

export const LOCATIONS = [
  {
    name: 'Viña del Mar',
    address: 'Etchevers Alto',
    city: 'Viña del Mar',
    region: 'Valparaíso'
  },
  {
    name: 'Quilpué',
    address: 'Cabo de hornos',
    city: 'Quilpué',
    region: 'Valparaíso'
  }
];

// src/utils/constants.js
export const SERVICES = [
    {
      id: 1,
      title: 'Servicio 24/7',
      description: 'Disponibles las 24 horas del día, los 7 días de la semana, incluso en días festivos y durante toque de queda.',
      icon: 'clock',
      image: images.services.service247,
      detailedDescription: [
        'Atención inmediata telefónica',
        'Servicio en toda la quinta región',
        'Disponibilidad en festivos',
        'Asistencia nocturna con permisos',
        'Coordinación en tiempo real'
      ]
    },
    {
      id: 2,
      title: 'Grúa y Remolque',
      description: 'Servicio de grúa con plataforma hidráulica para todo tipo de vehículos.',
      icon: 'truck',
      image: images.services.quilpue,
      detailedDescription: [
        'Remolque de vehículos livianos',
        'Traslado de vehículos pesados',
        'Rescate en desniveles',
        'Grúa con plataforma hidráulica',
        'Equipamiento especializado'
      ]
    },
    {
      id: 3,
      title: 'Puente de Baterías',
      description: 'Asistencia inmediata para problemas de batería y sistema eléctrico.',
      icon: 'battery',
      image: images.services.bateria,
      detailedDescription: [
        'Diagnóstico de batería',
        'Puente de emergencia',
        'Revisión del sistema de carga',
        'Venta e instalación de baterías nuevas',
        'Asistencia para arranque'
      ]
    },
    {
      id: 4,
      title: 'Cambio de Neumáticos',
      description: 'Servicio completo de asistencia para problemas con neumáticos en ruta.',
      icon: 'tire',
      image: images.services.rescate,
      detailedDescription: [
        'Cambio de rueda en ruta',
        'Reparación de pinchazos',
        'Inflado de neumáticos',
        'Balanceo de emergencia',
        'Traslado a vulcanización'
      ]
    },
    {
      id: 5,
      title: 'Traslado de Combustible',
      description: 'Servicio de emergencia para vehículos sin combustible en ruta.',
      icon: 'fuel',
      image: images.services.vina,
      detailedDescription: [
        'Entrega de combustible en ruta',
        'Asistencia en carretera',
        'Servicio para gasolina y diésel',
        'Cantidad necesaria para llegar a estación',
        'Disponible 24/7'
      ]
    },
    {
      id: 6,
      title: 'Traslado a Taller',
      description: 'Convenio con talleres mecánicos de confianza o traslado al taller de su preferencia.',
      icon: 'garage',
      image: images.services.valpo,
      detailedDescription: [
        'Red de talleres asociados',
        'Traslado a taller de preferencia',
        'Coordinación con mecánicos',
        'Diagnóstico preliminar',
        'Seguimiento del servicio'
      ]
    },
    {
      id: 7,
      title: 'Asistencia Mecánica',
      description: 'Diagnóstico y reparaciones básicas en el lugar para continuar su viaje.',
      icon: 'tools',
      image: images.services.service247,
      detailedDescription: [
        'Diagnóstico en ruta',
        'Reparaciones menores',
        'Revisión de sistemas básicos',
        'Soluciones de emergencia',
        'Recomendaciones técnicas'
      ]
    },
    {
      id: 8,
      title: 'Rescate en Carretera',
      description: 'Servicio especializado de rescate en rutas y carreteras de la región.',
      icon: 'rescue',
      image: images.services.service247,
      detailedDescription: [
        'Rescate en ruta 68',
        'Asistencia en autopistas',
        'Coordinación con autopistas',
        'Rescate en zonas complejas',
        'Equipo especializado'
      ]
    }
  ];
  
  // También agregamos categorías de servicios
  export const SERVICE_CATEGORIES = [
    {
      id: 'emergencias',
      title: 'Servicios de Emergencia',
      services: [1, 2, 8] // IDs de los servicios relacionados
    },
    {
      id: 'mecanica',
      title: 'Asistencia Mecánica',
      services: [3, 7]
    },
    {
      id: 'traslados',
      title: 'Traslados y Remolques',
      services: [2, 6]
    },
    {
      id: 'auxilios',
      title: 'Auxilios en Ruta',
      services: [4, 5]
    }
  ];